module.exports = __webpack_public_path__ + "static/img/SmileAnimation_passionfruit.09d0cef.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_passionfruit.gif
// module id = 5fru
// module chunks = 0